import React from "react";
import About from "../../../pages/Company/AboutUs/About";
import Section from "../../../pages/Company/AboutUs/Section";
// import Counter from "../../../pages/Company/AboutUs/Counter";
import Features from "../../../pages/Company/AboutUs/Features";
import Cta from "../../../pages/Company/AboutUs/Cta";
import CompanyTestimonial from "../../../pages/Company/AboutUs/CompanyTestimonial";
import MetaTags from "../../../helpers/Common/MetaTags";
import { getMetaConfig } from "../../../helpers/Common/metaConfig";

const AboutUs = () => {
  const aboutMeta = getMetaConfig('aboutUs');
  
  return (
    <React.Fragment>
      <MetaTags {...aboutMeta} />
      <Section />
      <About />
      {/* <Counter /> */}
      {/* <Features /> */}
      <Cta />
      {/* <CompanyTestimonial /> */}
    </React.Fragment>
  );
};

export default AboutUs;
